import * as React from 'react';
import classnames from 'classnames';
import { AppContext } from '@store/context'
import hocContext from '@hoc/context';
import { RouteComponentProps } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './index.scss';

interface State {
    onoff: boolean;
}
interface Props extends AppContext, RouteComponentProps { 
    to: string;
    back: boolean;
    label: string;
    white: boolean;
}

class ArrowNavigation extends React.Component<Props, State> {
    private interval: number;

    constructor(props: Props) {
        super(props);
        this.state = {
            onoff: true,
        }
    }
    
    public componentDidMount() {
        this.interval = window.setTimeout(() => {
            this.setState({onoff: false});
        }, 1500)
    }

    public componentWillUnmount() {
        window.clearInterval(this.interval);
    }

    render(): JSX.Element {
        const { onoff } = this.state;
        const { back, on, to, label, white } = this.props;
        
        return (
            <Link to={to} className={classnames('arrow-navigation-container', {back, white})}>
                <div className="arrow-navigation-wrapper">
                    <div className={classnames('arrow-navigation', {onoff: onoff || !on, back, forward: !back})}>
                        {
                            Array.from(Array(70).keys()).map((value: number) => (
                                <i key={`i-${value}`} className={classnames('i', `i-${value}`)}></i>
                            ))
                        }            
                    </div>
                </div>
                <div className={classnames('label', {off: !on})}>{ label }</div>
            </Link>
        );
    }
}

export default hocContext(ArrowNavigation);


// WEBPACK FOOTER //
// ./src/components/ArrowNavigation/index.tsx